var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-item",on:{"click":_vm.onClick}},[_c('div',{staticClass:"menu-layout",style:({
      background:
        _vm.backgroundType == 2 ? ("url(" + _vm.backgroundPicUrl + ")") : _vm.backgroundCode,
      'background-size': 'cover',
      'background-repeat': 'no-repeat'
    })},[_c('img',{staticClass:"menu-item-img",attrs:{"src":_vm.backgroundIconUrl}}),_c('p',{staticClass:"menu-item-title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }